import { TableTotalStat } from "../../../components/DataTable/TableTotals";
import { useTranslation } from "react-i18next";

type TrucksTableFooterProps = {
  shiftTotal?: number;
  currentHourLabel: string;
  currentHourSum?: number;
  isLoading: boolean;
};

const TrucksTableFooter: React.FC<TrucksTableFooterProps> = ({
  shiftTotal,
  currentHourLabel,
  currentHourSum,
  isLoading
}) => {
  const { t } = useTranslation("production");
  return (
    <div className="w-full pt-2 flex justify-end-safe items-center gap-4 md:gap-6 animate-fade-up border-t border-theme-border">
      <TableTotalStat label={t("trucksTable.totalTruckLoads")} value={shiftTotal} isLoading={isLoading} />
      <TableTotalStat label={t("trucksTable.hourTotal", { hour: currentHourLabel })} value={currentHourSum} isLoading={isLoading} />
    </div>
  )
};

export default TrucksTableFooter;
